import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Title, form sections and the preview while the offer loads. */
const OfferFormSkeleton = () => (
  <Stack gap={3} sx={{ maxWidth: 1120, mx: 'auto', width: '100%' }} aria-busy="true">
    <Skeleton variant="text" width="30%" height={40} />
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) 340px' },
      }}
    >
      <Stack gap={2}>
        <Skeleton variant="rounded" height={240} />
        <Skeleton variant="rounded" height={200} />
        <Skeleton variant="rounded" height={180} />
      </Stack>
      <Skeleton variant="rounded" height={360} />
    </Box>
  </Stack>
);

export default OfferFormSkeleton;
